import React from 'react';
import Reportes from 'src/pages/reportes/Reportes';
import {
	Routes, Route,
} from 'react-router-dom';

function RouterReportes() {
	return (
		<Routes>
			<Route
				path="/"
				element={(
					<Reportes />
				)}
			/>
		</Routes>
	);
}

export default RouterReportes;
